import React from "react";

const WhyIcmFifth = () => (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 36C8.0586 36 0 27.9414 0 18C0 8.0586 8.0586 0 18 0C27.9414 0 36 8.0586 36 18C36 27.9414 27.9414 36 18 36ZM18 12.6H10.8V16.2H27L18 7.2V12.6ZM9 19.8L18 28.8V23.4H25.2V19.8H9Z" fill="#283A97" />
    </svg>
)

export default WhyIcmFifth;